import { Box, Icon, IconButton, Text } from '@chakra-ui/react';
import { FaChevronLeft } from 'react-icons/fa';

interface IExecutionLogsHeaderProps {
  title: string;
  onClickBackButton?: () => void;
  customerName?: string;
}

const ExecutionLogsHeader = ({ title, onClickBackButton, customerName }: IExecutionLogsHeaderProps) => {

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Box display="flex" alignItems="center">
        {onClickBackButton ? (
          <Box display="flex" alignItems="center" >
            <IconButton
              size="sm"
              variant="ghost"
              onClick={onClickBackButton}
            >
              <Icon as={FaChevronLeft} color="bg.default" />
            </IconButton>
            <Text fontSize={20} fontWeight={500} color="#202224">
              {title}
            </Text>
          </Box>
        ) : (
          <Text fontSize={24} fontWeight={500} color="#202224">
            {title}
          </Text>
        )}
      </Box>
      {customerName && (
        <Box display="flex" alignItems="center">
          <Text fontSize={20} fontWeight={500} color="#202224">{customerName}</Text>
        </Box>
      )}
    </Box>
  );
};

export default ExecutionLogsHeader;